import { useMemo, useCallback } from 'react';
import { useQuery } from '@tanstack/react-query';
import { userService } from '@/services/user.service';
import { buildUserIdToLabelMap, resolveUserDisplayFromMap } from '@/utils/userDisplay';

/**
 * Loads company users once (react-query dedupes) and resolves stored user ids to display names.
 */
export function useUserDisplayResolver() {
  const { data: users = [], isLoading } = useQuery({
    queryKey: ['users', 'display-resolve'],
    queryFn: () => userService.getAll(),
    staleTime: 5 * 60 * 1000,
  });

  const map = useMemo(() => buildUserIdToLabelMap(users), [users]);

  const resolve = useCallback(
    (id: string | null | undefined, emptyLabel = '—') => resolveUserDisplayFromMap(map, id, emptyLabel),
    [map]
  );

  return { resolve, map, isLoading };
}
